export const REQUEST_MANAGER_PENDING_CLAIMS: string =
  'REQUEST_MANAGER_PENDING_CLAIMS';
export const SET_MANAGER_PENDING_CLAIMS: string = 'SET_MANAGER_PENDING_CLAIMS';

export const SEARCH_QUERY_INIT_VALUES = {
  lossDate: null,
  registrationNumber: null,
};

export const SEARCH_TYPE_IDS = {
  REGISTRATION_NUMBER: 'REGISTER',
  LOSS_DATE: 'LOSS_DATE',
  PRE_OPEN_DATE: 'PRE_OPEN_DATE',
};
